export const getLatestContractStatus = (contract) =>
    contract?.ultima_version_estado ?? contract?.estado_version;

export const getLatestVersionNexStatus = (contract) => {
    if (Number(contract?.tipo_contrato) !== 9) return '—';
    return contract?.ultima_version_nex_enviado ? 'Enviado' : 'Pendiente de envío';
};
